import React from 'react';
import { useNavigate } from 'react-router';

import Button from '~/components/button';
import Modal from '~/components/modals/modal';
import { accountSettingsRoute } from '~/routes';

import styles from '~/components/cancellation/cancellation.module.scss';

const OfferRedeemedModal = ({ isOpen, onClose, content }) => {
  const navigate = useNavigate();

  const handleClose = () => {
    navigate(accountSettingsRoute());
    onClose();
  };

  return (
    <Modal
      onClose={handleClose}
      isOpen={isOpen}
      className={styles.offerConfirmationModal}
    >
      <p className={styles.modalContent}>{content}</p>
      <Button onClick={handleClose}>Back to my account</Button>
    </Modal>
  );
};

export default OfferRedeemedModal;
